export default "__VITE_ASSET__CMqxexjj__"